// export const imageToBase64 = (file) => new Promise((resolve) => {
//   const reader = new FileReader();
//   reader.onload = function () {
//     const base64String = reader.result.replace('data:', '')
//       .replace(/^.+,/, '');
//     resolve(base64String);
//   };
//   reader.readAsDataURL(file);
// });
//
// export const calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth = 230, maxHeight = 64) => {
//   const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
//   return { width: srcWidth * ratio, height: srcHeight * ratio };
// };

// eslint-disable-next-line import/prefer-default-export
import { formatDateAsIso } from "./dateUtils";

export const resizeImage = (file, maxWidth = 460, maxHeight = 128) => {
	const reader = new FileReader();
	const image = new Image();
	const canvas = document.createElement("canvas");
	const resize = () => {
		let { width } = image;
		let { height } = image;
		if (width > height) {
			if (width > maxWidth) {
				height *= maxWidth / width;
				width = maxWidth;
			}
		} else if (height > maxHeight) {
			width *= maxHeight / height;
			height = maxHeight;
		}
		canvas.width = width;
		canvas.height = height;
		canvas.getContext("2d").drawImage(image, 0, 0, width, height);
		return canvas.toDataURL("image/png");
	};
	return new Promise((resolve, reject) => {
		if (!/image.*/.test(file.type)) {
			reject(new Error("Not an image"));
			return;
		}
		reader.addEventListener("load", readerEvent => {
			image.addEventListener("load", () => resolve(resize()));
			image.src = readerEvent.target.result;
		});
		reader.readAsDataURL(file);
	});
};

export const createDownloadLink = href => {
	Object.assign(document.createElement("a"), {
		href,
		download: `export-${formatDateAsIso(new Date())}`,
	}).click();
};

const eventTranslationKeys = {
	1: "drivers.events.newDriver",
	2: "drivers.events.fsManual",
	3: "drivers.events.fsPending",
	4: "drivers.events.fsRequested",
	5: "drivers.events.fsDone",
	6: "drivers.events.fsOverdue",
	7: "drivers.events.fsAdhoc",
	8: "drivers.events.fsFail",
	9: "drivers.events.fsFailFirst",
	10: "drivers.events.initRequested",
	11: "drivers.events.initFailed",
	12: "drivers.events.initSuccess",
	13: "drivers.events.uvvPending",
	14: "drivers.events.uvvRequested",
	15: "drivers.events.uvvDone",
	16: "drivers.events.uvvOverdue",
	17: "drivers.events.uvvFail",
	18: "drivers.events.fsCancel",
	19: "drivers.events.eventScheduled",
	20: "drivers.events.fsManualSa",
	21: "drivers.events.activated",
	22: "drivers.events.deactivated",
	23: "drivers.events.uvvLkwPending",
	24: "drivers.events.uvvLkwRequested",
	25: "drivers.events.uvvLkwDone",
	26: "drivers.events.uvvLkwOverdue",
	27: "drivers.events.uvvLkwFail",
	30: "drivers.events.photoControlRequest",
	31: "drivers.events.photoControlFail",
	32: "drivers.events.photoControlSuccess",
	33: "drivers.events.photoControlFailedFirst",
	34: "drivers.events.driverWelcome",
	47: "drivers.events.driverUpdate",
	81: "drivers.events.initStarted",
	90: "drivers.events.driverDelete",
};

export const getEventTitle = (eventType, metadataAttributes = [], translate) => {
	// Automated manual controls
	if (eventType >= 400) {
		return translate(`templates.types.${eventType}`);
	}
	// custom uvv controls
	if (eventType >= 300 && metadataAttributes && metadataAttributes.length > 0) {
		return (
			translate(`tenants.uvvs.${metadataAttributes[0]}`) +
			translate(`templates.types.${eventType}`)
		);
	}
	// other
	if (eventType > 100) {
		return translate(`templates.types.${eventType}`);
	}

	const translatationKey = eventTranslationKeys[eventType] || "drivers.events.next";
	return translate(translatationKey);
};
